import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "@/lib/auth";
import AppLayout from "@/components/AppLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import VerifyOtpPage from "@/pages/VerifyOtpPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import EventsPage from "@/pages/EventsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import BookingsPage from "@/pages/BookingsPage";
import BookingDetailPage from "@/pages/BookingDetailPage";
import ProfilePage from "@/pages/ProfilePage";
import OrganisePage from "@/pages/OrganisePage";
import OrganiserEventPage from "@/pages/OrganiserEventPage";
import PaymentReturnPage from "@/pages/PaymentReturnPage";
import AdminPage from "@/pages/admin/AdminPage";
import AdminTemplatesPage from "@/pages/admin/AdminTemplatesPage";
import AdminTemplateNewPage from "@/pages/admin/AdminTemplateNewPage";
import AdminEventNewPage from "@/pages/admin/AdminEventNewPage";
import AdminEventBookingsPage from "@/pages/admin/AdminEventBookingsPage";
import AdminEventHostsPage from "@/pages/admin/AdminEventHostsPage";
import AdminReviewQueuePage from "@/pages/admin/AdminReviewQueuePage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import AdminDirectoryImportPage from "@/pages/admin/AdminDirectoryImportPage";
import AdminBackupPage from "@/pages/admin/AdminBackupPage";
import AdminProvinceLCPage from "@/pages/admin/AdminProvinceLCPage";
import AdminCraftMasterPage from "@/pages/admin/AdminCraftMasterPage";
import AdminRoyalArchMasterPage from "@/pages/admin/AdminRoyalArchMasterPage";
import AdminComplimentaryEmailTemplatePage from "@/pages/admin/AdminComplimentaryEmailTemplatePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-otp" element={<VerifyOtpPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/payments/return" element={<PaymentReturnPage />} />

            {/* Password change lives outside the app shell so a forced
                first-login flow can't navigate away via the nav bar. */}
            <Route
              path="/change-password"
              element={<ProtectedRoute><ChangePasswordPage /></ProtectedRoute>}
            />

            {/* Authenticated shell */}
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/events" element={<EventsPage />} />
              <Route path="/events/:id" element={<EventDetailPage />} />
              <Route path="/bookings" element={<BookingsPage />} />
              <Route path="/bookings/:id" element={<BookingDetailPage />} />
              <Route path="/profile" element={<ProfilePage />} />

              <Route path="/organise" element={<ProtectedRoute requireRole="organiser"><OrganisePage /></ProtectedRoute>} />
              <Route path="/organise/:id" element={<ProtectedRoute requireRole="organiser"><OrganiserEventPage /></ProtectedRoute>} />

              <Route path="/admin" element={<ProtectedRoute requireRole="admin"><AdminPage /></ProtectedRoute>} />
              <Route path="/admin/templates" element={<ProtectedRoute requireRole="admin"><AdminTemplatesPage /></ProtectedRoute>} />
              <Route path="/admin/template-new" element={<ProtectedRoute requireRole="admin"><AdminTemplateNewPage /></ProtectedRoute>} />
              <Route path="/admin/templates/:id/edit" element={<ProtectedRoute requireRole="admin"><AdminTemplateNewPage /></ProtectedRoute>} />
              <Route path="/admin/events/new" element={<ProtectedRoute requireRole="admin"><AdminEventNewPage /></ProtectedRoute>} />
              <Route path="/admin/events/:id/edit" element={<ProtectedRoute requireRole="admin"><AdminEventNewPage /></ProtectedRoute>} />
              <Route path="/admin/events/:id/bookings" element={<ProtectedRoute requireRole="admin"><AdminEventBookingsPage /></ProtectedRoute>} />
              <Route path="/admin/event-hosts" element={<ProtectedRoute requireRole="admin"><AdminEventHostsPage /></ProtectedRoute>} />
              <Route path="/admin/review-queue" element={<ProtectedRoute requireRole="admin"><AdminReviewQueuePage /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute requireRole="admin"><AdminUsersPage /></ProtectedRoute>} />
              <Route path="/admin/directory-import" element={<ProtectedRoute requireRole="admin"><AdminDirectoryImportPage /></ProtectedRoute>} />
              <Route path="/admin/backup" element={<ProtectedRoute requireRole="admin"><AdminBackupPage /></ProtectedRoute>} />
              <Route path="/admin/province-lc" element={<ProtectedRoute requireRole="admin"><AdminProvinceLCPage /></ProtectedRoute>} />
              <Route path="/admin/craft-master" element={<ProtectedRoute requireRole="admin"><AdminCraftMasterPage /></ProtectedRoute>} />
              <Route path="/admin/royal-arch-master" element={<ProtectedRoute requireRole="admin"><AdminRoyalArchMasterPage /></ProtectedRoute>} />
              <Route path="/admin/comp-email-templates/:key" element={<ProtectedRoute requireRole="admin"><AdminComplimentaryEmailTemplatePage /></ProtectedRoute>} />
            </Route>

            <Route path="/" element={<Navigate to="/events" replace />} />
            <Route path="*" element={<Navigate to="/events" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
